module.exports = __webpack_public_path__ + "img/img2_m.a240318c.png";